import { bindActionCreators } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';
import { ActsActionCreators } from '../redux/acts/reducer';
import { AuthActionCreators } from '../redux/auth/reducer';
import { FinancesActionCreators } from '../redux/finances/reducer';
import { HeaderActionCreators } from '../redux/header/reducer';
import { OfficeTripActionCreators } from '../redux/officeTrip/reducer';
import { TripsActionCreators } from '../redux/trips/reducer';
const ActionsCreators = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, AuthActionCreators), ActsActionCreators), TripsActionCreators), HeaderActionCreators), OfficeTripActionCreators), FinancesActionCreators);
const useAppDispatch = () => {
    const dispatch = useDispatch();
    return bindActionCreators(ActionsCreators, dispatch);
};
export default useAppDispatch;
